/**
 * Centralized translations for System module
 * Contains all labels used across system components (indicators, requirements flows, etc.)
 */

export const SystemLabels = {
    it: {
        // Navigation labels
        home: 'Home',
        admin: 'Amministrazione',
        system: 'Sistema',
        organizationalChart: 'Organigramma',
        security: 'Sicurezza',
        rightsTree: 'Albero Diritti',
        dataImport: 'Import Dati',
        
        // Common labels
        close: 'Chiudi',
        save: 'Salva',
        saving: 'Salvataggio',
        success: 'Successo',
        error: 'Errore',
        info: 'Info',
        
        // Form fields - Indicators
        code: 'Codice',
        codeOfItem: 'Codice dell\'elemento',
        codeADT: 'Codice ADT',
        codeADTPlaceholder: 'Codice ADT dell\'unità',
        codeGEL: 'Codice GEL',
        codeGELPlaceholder: 'Codice GEL dell\' unità',
        codeATC: 'Codice ATC',
        codeATCPlaceholder: 'Codice ATC dell\' unità',
        codeLIS: 'Codice LIS',
        codeLISPlaceholder: 'Codice LIS dell\' unità',
        codeCND: 'Codice CND',
        codeCNDPlaceholder: 'Codice CND dell\' unità',
        pointsOfAttention: 'Punti di Attenzione',
        indicator: 'Indicatore',
        nameOfItem: 'Nome dell\'elemento',
        type: 'Tipo',
        qualitative: 'Qualitativo',
        quantitative: 'Quantitativo',
        reference: 'Riferimento',
        referenceOfItem: 'Riferimento dell\'elemento',
        dataSource: 'Origine dati',
        sourceOfItem: 'Origine dell\'elemento',
        notes: 'Note',
        descriptionOfItem: 'Descrizione dell\'elemento',
        
        // Actions
        add: 'Aggiungi',
        edit: 'Modifica',
        delete: 'Elimina',
        moveUp: 'Sposta su',
        moveDown: 'Sposta giù',
        goToEditMode: 'Passa alla modalità modifica',
        goToListMode: 'Passa alla modalità lista',
        saveData: 'Salva i dati',
        confirm: 'Conferma',
        cancel: 'Annulla',
        actions: 'Azioni',
        
        // Organizational Chart specific
        unsavedChanges: 'Ci sono modifiche non salvate. Vuoi salvare prima di uscire (le modifiche non salvate andranno perse)?',
        yes: 'Sì',
        no: 'No',
        codePlaceholder: 'Codice della business unit',
        name: 'Nome',
        namePlaceholder: 'Nome della business unit',
        group: 'Gruppo',
        editOrgChart: 'Modifica organigramma per questa unità',
        update: 'Aggiorna',
        confirmChanges: 'Le modifiche a questa unità non sono state confermate. Vuoi confermare le modifiche e salvare prima di procedere?',
        newBusinessUnit: 'Nuova unità di business',
        action: 'Azioni',
        regimen: 'Regime',
        startDate: 'Data inizio',
        endDate: 'Data fine',
        
        // Level labels
        scopeOfEvaluation: 'Ambito di valutazione',
        pointOfAttention: 'Punto di attenzione',
        
        // Messages
        dataJustUpdated: 'Dati appena aggiornati',
        savingData: 'Salvataggio dei dati',
        savingNewData: 'Stiamo salvando i tuoi nuovi dati',
        errorAccessingData: 'Si è verificato un errore nell\'accesso ai dati richiesti',
        noChangesAfterLastSave: 'Non ci sono cambiamenti dopo l\'ultimo salvataggio',
        indicatorsSavedWithSuccess: '{count} indicatori salvati con successo',
        nameMissingForItem: 'Il nome manca per l\'elemento #{index}',
        newIndicator: 'Nuovo indicatore',
        name: 'Nome',
        action: 'Azione',
        ok: 'OK',
        description: 'Descrizione',
        unnamed: 'Senza nome',
        newRight: 'Nuovo diritto',
        
        // Business Units specific
        missingNameForBU: 'Il nome manca per l\'unità organizzativa #{index}',
        missingTypeForBU: 'Il tipo manca per l\'unità organizzativa "{name}"',
        missingNameForRight: 'Il nome manca per il diritto #{index}',
        confirmDeleteRight: 'Sei sicuro di voler eliminare il diritto "{name}"?',
        attention: 'Attenzione',
        confirmDeleteNode: 'Sei sicuro di voler eliminare l\'unità',
        confirmDeleteNodeWithChildren: 'Sei sicuro di voler eliminare l\'unità',
        nodeMarkedForDeletion: 'Unità contrassegnata per l\'eliminazione. Sarà eliminata al prossimo salvataggio.',
        subUnit: 'sotto-unità',
        subUnits: 'sotto-unità',
        nothingToSave: 'Niente da salvare',
        nothingToSaveMessage: 'Non ci sono modifiche da salvare',
        savedSussessfullyWithNumberMessage: '{{number}} elementi salvati con successo',
        deletedSussessfullyWithNumberMessage: 'elementi eliminati con successo',
        savedAndDeletedUnitsMessage: 'elementi salvati e',
        savedMessage: 'elementi salvati con successo',
        deletedMessage: 'elementi eliminati con successo',
        andText: 'e',
        saveThisData: 'Salva questi dati',
        switchToTreeView: 'Passa alla vista ad albero',
        switchToListView: 'Passa alla vista a lista',
        
        // Form Custom Vocabularies specific
        formCustomVocs: 'Vocabolari custom form',
        vocabularies: 'Vocabolari',
        values: 'Valori',
        newVocabulary: 'Nuovo vocabolario',
        newValue: 'Nuovo valore',
        value: 'Valore',
        selectVocabulary: 'Seleziona un vocabolario per vedere i suoi valori',
        vocabularyName: 'Nome vocabolario',
        valueName: 'Nome valore',
        confirmDeleteVocabulary: 'Sei sicuro di voler eliminare questo vocabolario?',
        confirmDeleteValue: 'Sei sicuro di voler eliminare questo valore?',
        vocabularyCreated: 'Vocabolario creato con successo',
        valueCreated: 'Valore creato con successo',
        vocabularyDeleted: 'Vocabolario eliminato con successo',
        valueDeleted: 'Valore eliminato con successo',
        pleaseEnterVocabularyName: 'Inserisci il nome del vocabolario',
        pleaseEnterValueName: 'Inserisci il nome del valore e seleziona un vocabolario',
        changesSaved: 'Modifiche salvate con successo',
        selectVocabularyToViewValues: 'Seleziona un vocabolario dalla lista a sinistra per visualizzare i suoi valori',
        
        // Pagination and search
        searchVocabulary: 'Cerca vocabolario...',
        previous: 'Precedente',
        next: 'Successiva',
        page: 'Pagina',
        of: 'di',
        totalRecords: 'totali',
        noVocabulariesFound: 'Nessun vocabolario trovato per la ricerca',
        noVocabularies: 'Nessun vocabolario presente',
        
        // Configuration Management labels
        configurations: 'Configurazioni',
        systemConfigurations: 'Configurazioni di Sistema',
        manageSystemConfigurations: 'Gestisci le configurazioni di sistema',
        configurationDetails: 'Dettagli configurazione',
        selectConfigurationToEdit: 'Seleziona una configurazione da modificare',
        loadingConfiguration: 'Caricamento configurazione',
        noConfigurationFound: 'Nessuna configurazione trovata',
        noConfigurationsFound: 'Nessuna configurazione trovata',
        noFieldsInConfiguration: 'Nessun campo in questa configurazione',
        currentUserConfiguration: 'Configurazione utente corrente',
        retry: 'Riprova',
        errorLoadingConfigurations: 'Errore nel caricamento delle configurazioni',
        errorLoadingConfiguration: 'Errore nel caricamento della configurazione',
        errorUpdatingField: 'Errore nell\'aggiornamento del campo',
        fieldUpdatedSuccessfully: 'Campo aggiornato con successo',
        enabled: 'Abilitato',
        disabled: 'Disabilitato',
        on: 'On',
        off: 'Off',
        loading: 'Caricamento...',
        
        // Configuration field descriptions
        showType: 'Mostra il pulsante tipo "Interno/Esterno"',
        acpm: 'Mostra il pulsante ACPM nel campo note',
        showGender: 'Mostra il pulsante genere "Uomo/Donna"',
        
        // New Configuration Save functionality
        unsavedChanges: 'Modifiche non salvate',
        saveConfiguration: 'Salva configurazione',
        configurationSavedSuccessfully: 'Configurazione salvata con successo',
        errorSavingConfiguration: 'Errore nel salvataggio della configurazione',
        noChangesToSave: 'Nessuna modifica da salvare',
        
        // Language Selector
        languageSelector: {
            changeLanguage: 'Cambio lingua',
            selectLanguage: 'Seleziona Lingua',
            languageSelected: 'Lingua selezionata!',
            languageChanged: 'Lingua modificata correttamente'
        }
    },
    
    en: {
        // Navigation labels
        home: 'Home',
        admin: 'Administration',
        system: 'System',
        organizationalChart: 'Organizational Chart',
        security: 'Security',
        rightsTree: 'Rights Tree',
        dataImport: 'Data Import',
        
        // Common labels
        close: 'Close',
        save: 'Save',
        saving: 'Saving',
        success: 'Success',
        error: 'Error',
        info: 'Info',
        
        // Form fields - Indicators
        code: 'Code',
        codeOfItem: 'Code of item',
        codeADT: 'ADT Code',
        codeADTPlaceholder: 'ADT Code of the unit',
        codeGEL: 'GEL Code',
        codeGELPlaceholder: 'GEL Code of the unit',
        codeATC: 'ATC Code',
        codeATCPlaceholder: 'ATC Code of the unit',
        codeLIS: 'LIS Code',
        codeLISPlaceholder: 'LIS Code of the unit',
        codeCND: 'CND Code',
        codeCNDPlaceholder: 'CND Code of the unit',
        pointsOfAttention: 'Points of Attention',
        indicator: 'Indicator',
        nameOfItem: 'Name of item',
        type: 'Type',
        qualitative: 'Qualitative',
        quantitative: 'Quantitative',
        reference: 'Reference',
        referenceOfItem: 'Reference of item',
        dataSource: 'Data source',
        sourceOfItem: 'Source of item',
        notes: 'Notes',
        descriptionOfItem: 'Description of item',
        
        // Actions
        add: 'Add',
        edit: 'Edit',
        delete: 'Delete',
        moveUp: 'Move up',
        moveDown: 'Move down',
        goToEditMode: 'Go to edit mode',
        goToListMode: 'Go to list mode',
        saveData: 'Save data',
        confirm: 'Confirm',
        cancel: 'Cancel',
        actions: 'Actions',
        
        // Organizational Chart specific
        unsavedChanges: 'There are unsaved changes. Do you want to save before exiting (unsaved changes will be lost)?',
        yes: 'Yes',
        no: 'No',
        codePlaceholder: 'Code of the business unit',
        name: 'Name',
        namePlaceholder: 'Name of the business unit',
        group: 'Group',
        editOrgChart: 'Edit organizational chart for this unit',
        update: 'Update',
        confirmChanges: 'This unit changes were not confirmed. Do you want to confirm editing and save changes before proceed?',
        newBusinessUnit: 'New business unit',
        action: 'Action',
        regimen: 'Regimen',
        startDate: 'Start Date',
        endDate: 'End Date',
        
        // Level labels
        scopeOfEvaluation: 'Scope of evaluation',
        pointOfAttention: 'Point of attention',
        
        // Messages
        dataJustUpdated: 'Data just updated',
        savingData: 'Saving data',
        savingNewData: 'We are saving your new data',
        errorAccessingData: 'There was an error accessing the requested data',
        noChangesAfterLastSave: 'There are no changes after the last save',
        indicatorsSavedWithSuccess: '{count} indicators saved with success',
        nameMissingForItem: 'The name is missing for the item #{index}',
        newIndicator: 'New indicator',
        name: 'Name',
        action: 'Action',
        ok: 'OK',
        description: 'Description',
        unnamed: 'Unnamed',
        newRight: 'New right',
        
        // Business Units specific
        missingNameForBU: 'The name is missing for business unit #{index}',
        missingTypeForBU: 'The type is missing for business unit "{name}"',
        missingNameForRight: 'The name is missing for right #{index}',
        confirmDeleteRight: 'Are you sure you want to delete the right "{name}"?',
        attention: 'Attention',
        confirmDeleteNode: 'Are you sure you want to delete the unit',
        confirmDeleteNodeWithChildren: 'Are you sure you want to delete the unit',
        nodeMarkedForDeletion: 'Unit marked for deletion. It will be deleted on the next save.',
        subUnit: 'sub-unit',
        subUnits: 'sub-units',
        nothingToSave: 'Nothing to save',
        nothingToSaveMessage: 'There are no changes to save',
        savedSussessfullyWithNumberMessage: '{{number}} items saved successfully',
        deletedSussessfullyWithNumberMessage: 'items deleted successfully',
        savedAndDeletedUnitsMessage: 'items saved and',
        savedMessage: 'items saved successfully',
        deletedMessage: 'items deleted successfully',
        andText: 'and',
        saveThisData: 'Save this data',
        switchToTreeView: 'Switch to tree view',
        switchToListView: 'Switch to list view',
        
        // Form Custom Vocabularies specific
        formCustomVocs: 'custom Form vocabularies',
        vocabularies: 'Vocabularies',
        values: 'Values',
        newVocabulary: 'New vocabulary',
        newValue: 'New value',
        value: 'Value',
        selectVocabulary: 'Select a vocabulary to see its values',
        vocabularyName: 'Vocabulary name',
        valueName: 'Value name',
        confirmDeleteVocabulary: 'Are you sure you want to delete this vocabulary?',
        confirmDeleteValue: 'Are you sure you want to delete this value?',
        vocabularyCreated: 'Vocabulary created successfully',
        valueCreated: 'Value created successfully',
        vocabularyDeleted: 'Vocabulary deleted successfully',
        valueDeleted: 'Value deleted successfully',
        pleaseEnterVocabularyName: 'Please enter vocabulary name',
        pleaseEnterValueName: 'Please enter value name and select a vocabulary',
        changesSaved: 'Changes saved successfully',
        selectVocabularyToViewValues: 'Select a vocabulary from the left list to view its values',
        
        // Pagination and search
        searchVocabulary: 'Search vocabulary...',
        previous: 'Previous',
        next: 'Next',
        page: 'Page',
        of: 'of',
        totalRecords: 'total',
        noVocabulariesFound: 'No vocabularies found for the search',
        noVocabularies: 'No vocabularies available',
        
        // Configuration Management labels
        configurations: 'Configurations',
        systemConfigurations: 'System Configurations',
        manageSystemConfigurations: 'Manage system configurations',
        configurationDetails: 'Configuration details',
        selectConfigurationToEdit: 'Select a configuration to edit',
        loadingConfiguration: 'Loading configuration',
        noConfigurationFound: 'No configuration found',
        noConfigurationsFound: 'No configurations found',
        noFieldsInConfiguration: 'No fields in this configuration',
        currentUserConfiguration: 'Current user configuration',
        retry: 'Retry',
        errorLoadingConfigurations: 'Error loading configurations',
        errorLoadingConfiguration: 'Error loading configuration',
        errorUpdatingField: 'Error updating field',
        fieldUpdatedSuccessfully: 'Field updated successfully',
        enabled: 'Enabled',
        disabled: 'Disabled',
        on: 'On',
        off: 'Off',
        loading: 'Loading...',
        
        // Configuration field descriptions
        showType: 'Show type bit "Internal/External"',
        acpm: 'Show ACPM bit in notes field',
        showGender: 'Show gender bit "Male/Female"',
        
        // New Configuration Save functionality
        unsavedChanges: 'Unsaved changes',
        saveConfiguration: 'Save configuration',
        configurationSavedSuccessfully: 'Configuration saved successfully',
        errorSavingConfiguration: 'Error saving configuration',
        noChangesToSave: 'No changes to save',
        
        // Language Selector
        languageSelector: {
            changeLanguage: 'Change language',
            selectLanguage: 'Select Language',
            languageSelected: 'Language selected!',
            languageChanged: 'Language changed successfully'
        }
    }
}; 